<template>
  <div :style="{ height, width }" id="EchartsAnimate" ref="docement"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left1Data: {
      type: Object,
      default: () => {},
    },
  },
  data:function () {
      return {
          echartsData:{
            "size":21,
            "list":[
              {"dysl":"70","mc":"数据展示","dm":"01","sysl":"89"},
              {"dysl":"75","mc":"数据展示","dm":"02","sysl":"107"},
              {"dysl":"4","mc":"数据展示","dm":"03","sysl":"21"},
              {"dysl":"7","mc":"数据展示","dm":"04","sysl":"90"},
              {"dysl":"43","mc":"数据展示","dm":"05","sysl":"71"},
              {"dysl":"5","mc":"数据展示","dm":"06","sysl":"10"},
              {"dysl":"20","mc":"数据展示","dm":"08","sysl":"44"},
              {"dysl":"1","mc":"数据展示","dm":"09","sysl":"100"},
              {"dysl":"56","mc":"数据展示","dm":"10","sysl":"71"},
              {"dysl":"56","mc":"数据展示","dm":"11","sysl":"65"},
              {"dysl":"9429","mc":"数据展示","dm":"20","sysl":"12320"},
              {"dysl":"25597","mc":"数据展示","dm":"21","sysl":"29575"},
              {"dysl":"272","mc":"数据展示","dm":"22","sysl":"369"},
              {"dysl":"6040","mc":"数据展示","dm":"23","sysl":"7307"},
              {"dysl":"4203","mc":"数据展示","dm":"24","sysl":"4983"},
              {"dysl":"27","mc":"数据展示","dm":"25","sysl":"44"},
              {"dysl":"9679","mc":"数据展示","dm":"26","sysl":"12396"},
              {"dysl":"44","mc":"数据展示","dm":"27","sysl":"70"},
              {"dysl":"109","mc":"数据展示","dm":"28","sysl":"146"},
              {"dysl":"17","mc":"数据展示","dm":"30","sysl":"23"},
              {"dysl":"75","mc":"数据展示","dm":"90","sysl":"69"}
            ]
          }
      }
  },
  mounted(){
          this.loadEchartsAnimate()
  },
  methods:{
      chartsRelativeSize(percent, derection) {
          var windowW = this.$refs.docement.offsetWidth;
          var windowH = this.$refs.docement.offsetHeight
          var r = 0;
          if ('h' === derection) {
              r = percent * windowH / 100;
          } else {
              r = percent * windowW / 100;
          }
          return r;
      },
      loadEchartsAnimate(){
          var that = this
          var echarts = require('echarts');
          var myCharts = echarts.init(document.getElementById('EchartsAnimate'));
          var option = {
              color:['#407FFF','#00FFBA'],
              tooltip : {
                  trigger: 'axis',
                  textStyle:{
                      color:'#000',
                      fontSize: '12px'
                  },
                  formatter: function (params) {
                      var arr = [];
                      params.forEach(function (item) {
                          var N=item.seriesName;
                          var V = '';
                          if(item.value>100000000){//亿
                              V += (item.value/100000000).toFixed(1) + '亿';
                          }else if( item.value>10000){//万
                              V += (item.value/10000).toFixed(1) + '万';
                          }else{
                              V += item.value;
                          }
                          var a = {name:N,value:V};
                          arr.push(a);
                      });
                      var num = '';
                      arr.forEach(function (item) {
                          num += item.name+":"+item.value+"<br/>";
                      });
                      return params[0].name +"<br>"+ num;
                  }
              },
              grid: {
                  left: '25px',
                  right: '25px',
                  bottom: '9px',
                  top:'50px',
                  containLabel: true
              },
              legend: {
                  orient: 'horizontal',
                  top:'10px',
                  right: '20px',
                  itemWidth:15,
                  itemHeight:15,
                  textStyle:{
                      color:'#fff',
                      fontSize: '12px'
                  },
                  data:['上月','本月'],
                  
              },
              xAxis: [
                  {
                      type: 'category',
                      axisLine: {
                          lineStyle: {
                              type: 'solid',
                              color: '#093027',//左边线的颜色
                              width: '1'//坐标线的宽度
                          }
                      },
                      axisLabel: {
                          textStyle: {
                              color: '#fff',//坐标值得具体的颜色,
                              fontSize: '12px'
                          },
                          interval:0
                      },
                      axisTick:false,
                      data: []
                  }
              ],
              yAxis: [
                  {
                      type: 'value',
                      axisLine: {
                        lineStyle: {
                            type: 'solid',
                            color: '#2E3950',//左边线的颜色
                            width: '1'//坐标线的宽度
                        }
                      },
                      axisLabel: {
                        textStyle: {
                            color: '#e6e6e6',//坐标值得具体的颜色,
                            fontSize:'12px'
                        }
                      },
                      axisTick:false,
                      splitLine: {  //坐标轴在grid区域中的分隔线（网格中的横线）
                        show: false,
                        lineStyle: {
                            color: ['#2E3950'],
                            width: 1,
                            type: 'solid',
                        }
                      },
                      splitArea: {//坐标轴在grid区域中的分隔区域（间隔显示网格区域）
                        interval: 1, //显示间隔的规律
                        show: true,
                        areaStyle: {//分隔区域的样式
                            color: ['rgba(255,255,255,0.03)', 'rgba(255,255,255,0)']
                        }
                      }
                  }
              ],
              series : [
                  {
                      name:'上月',
                      type:'bar',
                      barGap:0,
                      barWidth:15,
                      data:[]
                  },{
                      name:'本月',
                      type:'bar',
                      barGap:0,
                      barWidth:15,
                      data:[]
                  }
              ]
          };
          for(var i=0;i<this.echartsData.list.length && i<5;i++){
              option.xAxis[0].data.push( that.echartsData.list[i].mc);
              option.series[0].data.push( that.echartsData.list[i].sysl);
              option.series[1].data.push( that.echartsData.list[i].dysl);
          }
          myCharts.setOption(option);

          if(window.hbfxInterval){
              clearInterval(window.hbfxInterval);
          }
          window.hbfxIndex = 0;
          window.hbfxInterval = setInterval(function () {
              option.xAxis[0].data.shift();
              option.xAxis[0].data.push( that.echartsData.list[window.hbfxIndex% that.echartsData.list.length].mc);

              option.series[0].data.shift();
              option.series[0].data.push( that.echartsData.list[window.hbfxIndex% that.echartsData.list.length].sysl);

              option.series[1].data.shift();
              option.series[1].data.push( that.echartsData.list[window.hbfxIndex% that.echartsData.list.length].dysl);

              myCharts.setOption(option);
              window.hbfxIndex ++;
          },2000)
      }
  }
}
</script>
<style lang="less">
  .min-body{
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #010827;
  }
  
</style>
